import React, { Component } from "react";
import { Col, Form, Row, Button, Alert, Image } from "react-bootstrap";
import "./motorpolicies.css";
import configData from "../config.json";
import { toast } from "react-toastify";
import tatalogo from './tataaig.jpeg';

export default class MQuotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      requestId: sessionStorage.getItem("requestId"),
      regno_1: sessionStorage.getItem("regno_1"),
      regno_2: sessionStorage.getItem("regno_2"),
      regno_3: sessionStorage.getItem("regno_3"),
      regno_4: sessionStorage.getItem("regno_4"),
      business_type: sessionStorage.getItem("business_type"),
      proposer_type: sessionStorage.getItem("proposer_type"),
      plan_type: sessionStorage.getItem("plan_type"),
      pol_start_date: sessionStorage.getItem("pol_start_date"),
      prev_pol_start_date: sessionStorage.getItem("prev_pol_start_date"),
      prev_pol_end_date: sessionStorage.getItem("prev_pol_end_date"),
      bletpstart: sessionStorage.getItem("bletpstart"),
      bletpend: sessionStorage.getItem("bletpend"),
      bleodstart: sessionStorage.getItem("bleodstart"),
      bleodend: sessionStorage.getItem("bleodend"),
      isLoading: true,
      integId: 327,
      fetchError: false,
      errorType: null,
      isOnline: navigator.onLine,
      baseQuoteData: null,
      addonQuoteData: null,
      quote_id: "",
      proposal_id: "",
      vehicle_idv: "",
      countdown: 30,
      showCountdown: true,
      timerCompleted: false,
    };
    this.countdownTimer = null;
  }

  componentDidMount() {
    this.startCountdownTimer();
    window.addEventListener('online', this.handleOnlineStatus);
    window.addEventListener('offline', this.handleOfflineStatus);
    this.checkForUpdatedQuote();

  }

  startCountdownTimer = () => {
    this.countdownTimer = setInterval(() => {
      this.setState((prevState) => {
        const newCountdown = prevState.countdown - 1;
        if (newCountdown <= 0) {
          clearInterval(this.countdownTimer);
          if (this.validateSession()) {
            this.fetchBaseQuote();
          } else {
            this.handleSessionError();
          }
          return {
            countdown: 0,
            showCountdown: false,
            timerCompleted: true,
            isLoading: false
          };
        }
        return { countdown: newCountdown };
      });
    }, 1000);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnlineStatus);
    window.removeEventListener('offline', this.handleOfflineStatus);
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  }

  handleOnlineStatus = () => {
    this.setState({ isOnline: true });
    this.showToast("Connection restored.", "success");
  };

  handleOfflineStatus = () => {
    this.setState({ isOnline: false, fetchError: true, errorType: 'network' });
    this.showToast("No internet connection. Please check your network.", "error");
  };

  validateSession = () => {
    const { sId, uId, requestId } = this.state;
    return sId && uId && requestId;
  };

  handleSessionError = () => {
    this.setState({
      isLoading: false,
      fetchError: true,
      errorType: 'session',
      timerCompleted: true,
      showCountdown: false
    });
    this.showToast("Session expired or invalid. Please start over.", "error");
  };

  checkForUpdatedQuote = () => {
    const updatedQuoteData = sessionStorage.getItem("updatedQuoteData");
    if (updatedQuoteData) {
      try {
        const parsedData = JSON.parse(updatedQuoteData);
        this.setState({ addonQuoteData: parsedData });
        sessionStorage.removeItem("updatedQuoteData");
        this.showToast("Updated quote with add-ons loaded successfully!", "success");
      } catch (error) {
        console.error("Error parsing updated quote data:", error);
        sessionStorage.removeItem("updatedQuoteData");
      }
    }
  };

  showToast = (msg, type = "success") => {
    const toastMethods = {
      success: toast.success,
      error: toast.error,
      warning: toast.warn,
      info: toast.info
    };
    toastMethods[type](msg);
  };

  fetchBaseQuote = () => {
    if (!navigator.onLine) {
      this.setState({ fetchError: true, errorType: 'network', isOnline: false });
      this.showToast("No internet connection.", "error");
      return;
    }
    if (!this.validateSession()) {
      this.handleSessionError();
      return;
    }
    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", this.state.integId);
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        console.log("Base Quote Response:", JSON.stringify(data, null, 2));
        this.processBaseQuoteResponse(data);
      })
      .catch((error) => {
        console.error("Error fetching base quote:", error);
        this.setState({ fetchError: true, errorType: 'api' });
        this.showToast("Failed to fetch quote data.", "error");
      });
  };

  processBaseQuoteResponse = (data) => {
    if (data.status === "success" && data.data) {
      try {
        const responseData = data.data;
        if (responseData.status && responseData.status < 0) {
          this.showToast(responseData.message_txt || "Error in quote", "error");
          this.setState({ fetchError: true, errorType: 'api' });
          return;
        }
        const quoteData = responseData.data;
        if (!quoteData) {
          this.showToast("No quote data found", "error");
          this.setState({ fetchError: true, errorType: 'api' });
          return;
        }
        if (quoteData.proposal_id) {
          sessionStorage.setItem("proposal_id", quoteData.proposal_id);
        }
        this.storeQuoteDetailsForAddons(quoteData, responseData);
        const normalizedQuote = this.normalizeQuoteData(quoteData, responseData);
        console.log("=== QUOTE DATA RECEIVED (Waiting for 30-second timer...) ===");
        console.log("Net Premium:", normalizedQuote.net_premium);
        console.log("Total Premium:", normalizedQuote.total_premium);
        console.log("GST Amount:", normalizedQuote.gst_amount);
        this.setState({
          baseQuoteData: normalizedQuote,
          quote_id: quoteData.quote_id || "",
          proposal_id: quoteData.proposal_id || "",
          vehicle_idv: quoteData.data?.vehicle_idv || "0",
        });
        console.log("✅ Quote ready. Waiting for timer to complete...");
      } catch (error) {
        console.error("Error processing base quote:", error);
        this.showToast("Error processing quote data", "error");
        this.setState({ fetchError: true, errorType: 'api' });
      }
    } else {
      this.showToast("No quote data received", "error");
      this.setState({ fetchError: true, errorType: 'api' });
    }
  };

  storeQuoteDetailsForAddons = (quoteData, responseData) => {
    const addonPageData = {
      quote_id: quoteData.quote_id,
      proposal_id: quoteData.proposal_id,
      vehicle_idv: quoteData.data?.vehicle_idv || "0",
      place_reg: quoteData.place_reg || "MUMBAI",
      place_reg_no: quoteData.place_reg_no || "99",
      proposer_pincode: quoteData.proposer_pincode || "400001",
      vehicle_make: quoteData.vehicle_make || "",
      vehicle_model: quoteData.vehicle_model || "",
      vehicle_variant: quoteData.vehicle_variant || "",
      dor: quoteData.dor || "",
      man_year: quoteData.man_year || "",
      manu_month: quoteData.manu_month || "",
      make_code: quoteData.make_code || "",
      model_code: quoteData.model_code || "",
      variant_code: quoteData.variant_code || "",
      pre_pol_ncb: quoteData.pre_pol_ncb || (this.state.business_type === "Roll Over" ? "20" : "0"),
    };
    sessionStorage.setItem("quoteDetailsForAddons", JSON.stringify(addonPageData));
  };

  normalizeQuoteData = (quoteData, responseData) => {
    const premiumBreakup = quoteData.premium_break_up || {};
    const dataSection = quoteData.data || {};
    const polDetails = quoteData.pol_dlts || {};
    console.log("=== PREMIUM DEBUG INFO ===");
    console.log("Premium Breakup:", JSON.stringify(premiumBreakup, null, 2));
    console.log("Data Section:", JSON.stringify(dataSection, null, 2));
    console.log("Policy Details:", JSON.stringify(polDetails, null, 2));
    const extractedNetPremium = this.extractNetPremium(premiumBreakup, dataSection, polDetails);
    const extractedTotalPremium = this.extractTotalPremium(premiumBreakup, dataSection, polDetails);
    const extractedGST = this.extractGSTAmount(premiumBreakup, dataSection, polDetails);
    console.log("Extracted Net Premium:", extractedNetPremium);
    console.log("Extracted Total Premium:", extractedTotalPremium);
    console.log("Extracted GST:", extractedGST);
    const paUnnamedPremium = this.extractPAUnnamedPremium(premiumBreakup);
    const paPaidPremium = this.extractPAPaidPremium(premiumBreakup);
    console.log("PA Unnamed Premium:", paUnnamedPremium);
    console.log("PA Paid Premium:", paPaidPremium);
    console.log("=== END PREMIUM DEBUG ===");
    return {
      quote_id: quoteData.quote_id,
      proposal_id: quoteData.proposal_id,
      policy_id: quoteData.policy_id,
      quote_no: quoteData.quote_no,
      business_type: quoteData.business_type,
      proposer_type: quoteData.proposer_type,
      plan_type: quoteData.plan_type,
      pol_start_date: quoteData.pol_start_date,
      pol_end_date: quoteData.pol_end_date,
      vehicle_make: quoteData.vehicle_make,
      vehicle_model: quoteData.vehicle_model,
      vehicle_variant: quoteData.vehicle_variant,
      dor: quoteData.dor,
      man_year: quoteData.man_year,
      regno_1: quoteData.regno_1,
      regno_2: quoteData.regno_2,
      regno_3: quoteData.regno_3,
      regno_4: quoteData.regno_4,
      place_reg: quoteData.place_reg,
      vehicle_idv: dataSection.vehicle_idv || polDetails.vehicle_idv || 0,
      net_premium: extractedNetPremium,
      total_premium: extractedTotalPremium,
      gst_amount: extractedGST,
      pa_unnamed_premium: paUnnamedPremium,
      pa_paid_premium: paPaidPremium,
      raw_data: quoteData,
      premium_break_up: premiumBreakup,
      data: dataSection,
      pol_dlts: polDetails
    };
  };

  extractNetPremium = (premiumBreakup, dataSection, polDetails) => {
    let value = 0;
    if (premiumBreakup.net_premium && parseFloat(premiumBreakup.net_premium) > 0) {
      value = parseFloat(premiumBreakup.net_premium);
    } else if (dataSection.net_premium && parseFloat(dataSection.net_premium) > 0) {
      value = parseFloat(dataSection.net_premium);
    } else if (dataSection.netPremium && parseFloat(dataSection.netPremium) > 0) {
      value = parseFloat(dataSection.netPremium);
    } else if (premiumBreakup.total_od_premium && premiumBreakup.total_tp_premium) {
      const odTotal = premiumBreakup.total_od_premium.total_od || 0;
      const tpTotal = premiumBreakup.total_tp_premium.total_tp_prem || 0;
      value = parseFloat(odTotal) + parseFloat(tpTotal);
    }
    return value;
  };

  extractTotalPremium = (premiumBreakup, dataSection, polDetails) => {
    let value = 0;
    if (premiumBreakup.final_premium && parseFloat(premiumBreakup.final_premium) > 0) {
      value = parseFloat(premiumBreakup.final_premium);
    } else if (premiumBreakup.total_premium && parseFloat(premiumBreakup.total_premium) > 0) {
      value = parseFloat(premiumBreakup.total_premium);
    } else if (premiumBreakup.gross_premium && parseFloat(premiumBreakup.gross_premium) > 0) {
      value = parseFloat(premiumBreakup.gross_premium);
    } else if (dataSection.final_premium && parseFloat(dataSection.final_premium) > 0) {
      value = parseFloat(dataSection.final_premium);
    }
    return value;
  };

  extractGSTAmount = (premiumBreakup, dataSection, polDetails) => {
    let value = 0;
    if (premiumBreakup.igst_prem && parseFloat(premiumBreakup.igst_prem) > 0) {
      value = parseFloat(premiumBreakup.igst_prem);
    } else if (premiumBreakup.prem_gst && parseFloat(premiumBreakup.prem_gst) > 0) {
      value = parseFloat(premiumBreakup.prem_gst);
    } else if (premiumBreakup.gst_amount && parseFloat(premiumBreakup.gst_amount) > 0) {
      value = parseFloat(premiumBreakup.gst_amount);
    } else if (premiumBreakup.final_premium && premiumBreakup.net_premium) {
      value = parseFloat(premiumBreakup.final_premium) - parseFloat(premiumBreakup.net_premium);
    }
    return value;
  };

  extractPAUnnamedPremium = (premiumBreakup) => {
    if (!premiumBreakup || !premiumBreakup.total_tp_premium) return 0;
    const tpPremium = premiumBreakup.total_tp_premium;
    if (tpPremium.pa_unnamed_prem !== undefined) {
      return parseFloat(tpPremium.pa_unnamed_prem) || 0;
    }
    return 0;
  };

  extractPAPaidPremium = (premiumBreakup) => {
    if (!premiumBreakup || !premiumBreakup.total_tp_premium) return 0;
    const tpPremium = premiumBreakup.total_tp_premium;
    if (tpPremium.pa_paid_driver_prem !== undefined) {
      return parseFloat(tpPremium.pa_paid_driver_prem) || 0;
    }
    return 0;
  };

  handleProceedToBuy = (quoteData, isAddon = false) => {
    if (quoteData && (quoteData.proposal_id || quoteData.quote_id)) {
      sessionStorage.setItem("selectedQuoteData", JSON.stringify(quoteData));
      sessionStorage.setItem("isAddonQuote", isAddon.toString());
      if (quoteData.proposal_id) {
        sessionStorage.setItem("proposal_id", quoteData.proposal_id);
      }
      if (quoteData.premium_break_up && quoteData.premium_break_up.total_tp_premium && typeof quoteData.premium_break_up.total_tp_premium.pa_cover_prem !== "undefined") {
        const paCoverPrem = quoteData.premium_break_up.total_tp_premium.pa_cover_prem;
        sessionStorage.setItem("pa_cover_prem", paCoverPrem.toString());
      }
      this.showToast("Proceeding to vehicle information...", "success");
      setTimeout(() => {
        window.location.href = "/mvinfo";
      }, 1000);
    } else {
      this.showToast("Quote data not available. Please refresh and try again.", "error");
    }
  };

  handleBackToVehicleDetails = () => {
    window.location.href = "/motorquotes";
  };

  renderQuoteCard = (quoteData, isAddon = false) => {
    if (!quoteData) {
      return <Alert variant="warning">No quote data available</Alert>;
    }
    let netPremium = parseFloat(quoteData.net_premium) || 0;
    let totalPremium = parseFloat(quoteData.total_premium) || 0;
    let gstAmount = parseFloat(quoteData.gst_amount) || 0;
    if (totalPremium === 0 && netPremium > 0) {
      gstAmount = netPremium * 0.18;
      totalPremium = netPremium + gstAmount;
    }
    if (gstAmount === 0 && totalPremium > 0 && netPremium > 0) {
      gstAmount = totalPremium - netPremium;
    }
    return (
      <div className="mb-4 p-4 shadow-sm" style={{ border: isAddon ? "3px solid #28a745" : "2px solid #007bff", borderRadius: "12px", backgroundColor: isAddon ? "#f8fff8" : "#f8f9ff" }}>
        {isAddon && (
          <Alert variant="success" className="mb-3">
            <h5 className="mb-1">Updated Quote with Add-Ons</h5>
            <small>Enhanced coverage with your selected add-ons applied</small>
          </Alert>
        )}
        <Row>
          <Col lg="1" className="d-flex align-items-start justify-content-center pt-2">

            <Image style={{ width: "auto", height: "100px" }} src={tatalogo} alt="TATA AIG" />
          </Col>
          <Col lg="2">
            <h6 className="text-primary mb-3">Policy Details</h6>
            <div className="small">
              <p className="mb-2"><strong>Business Type:</strong> {quoteData.business_type}</p>
              <p className="mb-2"><strong>Plan Type:</strong> {quoteData.plan_type}</p>
              <p className="mb-2"><strong>Registration:</strong> <span className="text-monospace">{quoteData.regno_1}{String(quoteData.regno_2).padStart(2, '0')}{quoteData.regno_3}{quoteData.regno_4}</span></p>
              <p className="mb-2"><strong>Policy Period:</strong><br /><small className="text-muted">{quoteData.pol_start_date} to {quoteData.pol_end_date}</small></p>
              {quoteData.quote_no && <p className="mb-0"><strong>Quote No:</strong><small className="text-muted"> {quoteData.quote_no}</small></p>}
            </div>
          </Col>
          <Col lg="2">
            <h6 className="text-info mb-3">Vehicle Information</h6>
            <div className="small">
              <p className="mb-2"><strong>Make:</strong> {quoteData.vehicle_make}</p>
              <p className="mb-2"><strong>Model:</strong> {quoteData.vehicle_model}</p>
              <p className="mb-2"><strong>Variant:</strong> {quoteData.vehicle_variant}</p>
              <p className="mb-2"><strong>Year:</strong> {quoteData.man_year}</p>
              <p className="mb-2"><strong>Registration Date:</strong> {quoteData.dor}</p>
            </div>
          </Col>
          <Col lg="3">

            <div className="bg-light p-3 rounded">

              {/* Loop all OD Premium values */}
              <strong>Own Damage (OD):</strong>
              {quoteData?.premium_break_up?.total_od_premium &&
                Object.entries(quoteData.premium_break_up.total_od_premium.od || {}).map(([key, value]) => (
                  <div className="d-flex justify-content-between mb-1 small" key={key}>
                    <span>{key.replace(/_/g, " ").toUpperCase()}:</span>
                    <span>₹{Math.round(value).toLocaleString()}</span>
                  </div>
                ))
              }

              {/* Add-ons Section */}
              {quoteData?.premium_break_up?.total_addOns && (
                <>
                  <hr />
                  <strong>Add-Ons:</strong>
                  {Object.entries(quoteData.premium_break_up.total_addOns).map(([key, value]) => (
                    value > 0 && (
                      <div className="d-flex justify-content-between mb-1 small" key={key}>
                        <span>{key.replace(/_/g, " ").toUpperCase()}:</span>
                        <span>₹{Math.round(value).toLocaleString()}</span>
                      </div>
                    )
                  ))}
                </>
              )}

              {/* TP Section */}
              {quoteData?.premium_break_up?.total_tp_premium && (
                <>
                  <hr />
                  <strong>Third Party (TP):</strong>
                  {Object.entries(quoteData.premium_break_up.total_tp_premium).map(([key, value]) => (
                    value > 0 && (
                      <div className="d-flex justify-content-between mb-1 small" key={key}>
                        <span>{key.replace(/_/g, " ").toUpperCase()}:</span>
                        <span>₹{Math.round(value).toLocaleString()}</span>
                      </div>
                    )
                  ))}
                </>
              )}

              <hr />

              {/* GST */}
              <div className="d-flex justify-content-between mb-2">
                <span><strong>GST:</strong></span>
                <span>₹{Math.round(quoteData.premium_break_up.igst_prem || 0).toLocaleString()}</span>
              </div>

              {/* FINAL PREMIUM */}
              <div className="d-flex justify-content-between">
                <span><strong>TOTAL PAYABLE:</strong></span>
                <h5 className="text-success mb-0">₹{Math.round(quoteData.premium_break_up.final_premium).toLocaleString()}</h5>
              </div>
            </div>
          </Col>
          <Col lg="3">
            <h6 className="text-success mb-3">PREMIUM BREAKDOWN</h6>
            <div className="bg-light p-3 rounded">
              <div className="d-flex justify-content-between mb-2">
                <span><strong>NET PREMIUM:</strong></span>
                <span className="text-success">₹{Math.round(netPremium).toLocaleString()}</span>
              </div>
              {quoteData.pa_unnamed_premium > 0 && (
                <div className="d-flex justify-content-between mb-2">
                  <span className="small">PA UNNAMED:</span>
                  <span className="small text-info">₹{Math.round(quoteData.pa_unnamed_premium).toLocaleString()}</span>
                </div>
              )}
              {quoteData.pa_paid_premium > 0 && (
                <div className="d-flex justify-content-between mb-2">
                  <span className="small">PA PAID DRIVER:</span>
                  <span className="small text-info">₹{Math.round(quoteData.pa_paid_premium).toLocaleString()}</span>
                </div>
              )}
              <div className="d-flex justify-content-between mb-2">
                <span>GST (18%):</span>
                <span>₹{Math.round(gstAmount).toLocaleString()}</span>
              </div>
              <hr className="my-2" />
              <div className="d-flex justify-content-between">
                <span><strong>TOTAL PREMIUM:</strong></span>
                <h5 className="text-success mb-0">₹{Math.round(totalPremium).toLocaleString()}</h5>
              </div>
            </div>
          </Col>

          <Col lg="1" className="d-flex flex-column justify-content-center align-items-center">
            <Button onClick={() => this.handleProceedToBuy(quoteData, isAddon)} className="rounded w-100" variant={isAddon ? "success" : "primary"} size="sm">
              Buy Now<br /><strong>₹{Math.round(totalPremium).toLocaleString()}</strong>
            </Button>
            {isAddon && (
              <div className="text-center mt-2">
                <small className="text-success"><strong>Recommended</strong></small>
              </div>
            )}
          </Col>
        </Row>

      </div>
    );
  };

  getErrorIcon = (errorType) => {
    const icons = { network: 'bi-wifi-off', timeout: 'bi-hourglass-split', server: 'bi-server', session: 'bi-shield-exclamation', api: 'bi-exclamation-octagon', unknown: 'bi-exclamation-triangle' };
    return icons[errorType] || icons.unknown;
  };
  render() {
    const {
      baseQuoteData,
      addonQuoteData,
      isLoading,
      fetchError,
      errorType,
      retryCount,
      maxRetries,
      isAutoRetrying,
      elapsedTime,
      isOnline,
      countdown,
      showCountdown
    } = this.state;

    // Loading state with 30-second static countdown timer
    if (isLoading || isAutoRetrying) {
      // Calculate progress percentage (30 seconds total)
      const progressPercent = ((30 - countdown) / 30) * 100;
      const circumference = 2 * Math.PI * 70; // radius = 70
      const strokeDashoffset = circumference - (progressPercent / 100) * circumference;

      return (
        <div className="text-center mt-5">
          <div className="bgalphacolor p-4">
            <h6 className="logoskybluecolor mb-4">FETCHING BEST QUOTES</h6>

            {/* Circular Progress Timer */}
            <div className="mb-4" style={{ position: 'relative', display: 'inline-block' }}>
              <svg width="180" height="180" style={{ transform: 'rotate(-90deg)' }}>
                {/* Background circle */}
                <circle
                  cx="90"
                  cy="90"
                  r="70"
                  stroke="#e9ecef"
                  strokeWidth="12"
                  fill="none"
                />
                {/* Progress circle */}
                <circle
                  cx="90"
                  cy="90"
                  r="70"
                  stroke={countdown <= 10 ? '#dc3545' : countdown <= 20 ? '#ffc107' : '#0d6efd'}
                  strokeWidth="12"
                  fill="none"
                  strokeLinecap="round"
                  strokeDasharray={circumference}
                  strokeDashoffset={strokeDashoffset}
                  style={{ transition: 'stroke-dashoffset 1s linear, stroke 0.5s ease' }}
                />
              </svg>
              {/* Countdown number in center */}
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '3rem',
                  fontWeight: 'bold',
                  color: countdown <= 10 ? '#dc3545' : countdown <= 20 ? '#ffc107' : '#0d6efd'
                }}
              >
                {countdown}
              </div>
            </div>

            <p className="text-muted mb-3" style={{ fontSize: '1.1rem' }}>
              {countdown > 0 ? 'SECONDS REMAINING' : 'ALMOST THERE...'}
            </p>

            {/* Loading dots animation */}
            <div className="d-flex justify-content-center mb-4">
              {[1, 2, 3, 4, 5].map(i => (
                <div
                  key={i}
                  className={`spinner-grow text-${['primary', 'success', 'danger', 'warning', 'info'][i - 1]} me-2`}
                  role="status"
                  style={{
                    animationDelay: `${i * 0.1}s`,
                    width: '1rem',
                    height: '1rem'
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              ))}
            </div>

            <h5 className="mb-2">
              {isAutoRetrying
                ? `RETRYING... (ATTEMPT ${retryCount}/${maxRetries})`
                : 'PLEASE WAIT'}
            </h5>
            <p className="text-muted">
              {isAutoRetrying
                ? 'Retrying to fetch your quotes...'
                : 'We are preparing your insurance quotes from TATA AIG...'}
            </p>

            {/* Progress bar */}
            <div className="mx-auto mt-4" style={{ maxWidth: '400px' }}>
              <div className="progress" style={{ height: '8px', borderRadius: '4px' }}>
                <div
                  className={`progress-bar ${countdown <= 10 ? 'bg-danger' : countdown <= 20 ? 'bg-warning' : 'bg-primary'}`}
                  role="progressbar"
                  style={{
                    width: `${progressPercent}%`,
                    transition: 'width 1s linear'
                  }}
                  aria-valuenow={progressPercent}
                  aria-valuemin="0"
                  aria-valuemax="100"
                />
              </div>
              <small className="text-muted mt-2 d-block">
                {Math.round(progressPercent)}% Complete
              </small>
            </div>

            {/* Status messages */}
            <div className="mt-4">
              <Alert variant="info" className="mx-auto" style={{ maxWidth: '500px' }}>
                <div className="d-flex align-items-center justify-content-center">
                  <div className="spinner-border spinner-border-sm text-info me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <span>
                    {countdown > 24 && 'Connecting to TATA AIG servers...'}
                    {countdown <= 24 && countdown > 18 && 'Validating vehicle details...'}
                    {countdown <= 18 && countdown > 12 && 'Processing insurance data...'}
                    {countdown <= 12 && countdown > 6 && 'Calculating premium...'}
                    {countdown <= 6 && countdown > 0 && 'Finalizing your quote...'}
                    {countdown === 0 && 'Almost done...'}
                  </span>
                </div>
              </Alert>
            </div>

            {!isOnline && (
              <Alert variant="warning" className="mt-3 mx-auto" style={{ maxWidth: '500px' }}>
                <i className="bi bi-wifi-off me-2"></i>
                You appear to be offline. Please check your connection.
              </Alert>
            )}
          </div>
        </div>
      );
    }

    // Enhanced error state with categorized messages
    if (fetchError && !baseQuoteData && !addonQuoteData) {
      const errorIcon = this.getErrorIcon(errorType);
      // const errorMessage = this.getErrorMessage(errorType);
      const isSessionError = errorType === 'session';
      const canRetry = isOnline && !isSessionError;

      return (
        <div className="bgalphacolor">
          <h3 className="logoskybluecolor">SATP Motor Insurance Quotes</h3>
          <div className="text-center mt-5">
            <Alert variant="danger" className="text-center p-4 mx-auto" style={{ maxWidth: '700px' }}>
              <i className={`bi ${errorIcon}`} style={{ fontSize: '3rem', color: '#dc3545' }}></i>
              <h5 className="mt-3">
                {errorType === 'network' && 'No Internet Connection'}
                {errorType === 'timeout' && 'Request Timed Out'}
                {errorType === 'server' && 'Server Error'}
                {errorType === 'session' && 'Session Expired'}
                {errorType === 'api' && 'Invalid Request'}
                {!errorType && 'Failed to Load Quotes'}
              </h5>
              {/* <p className="mb-3">{errorMessage}</p> */}

              {/* Retry info */}
              {retryCount > 0 && !isAutoRetrying && (
                <Alert variant="warning" className="small">
                  <i className="bi bi-info-circle me-1"></i>
                  Attempted {retryCount} automatic {retryCount === 1 ? 'retry' : 'retries'}
                </Alert>
              )}

              {/* Connection status */}
              {!isOnline && (
                <Alert variant="warning" className="small mb-3">
                  <i className="bi bi-wifi-off me-1"></i>
                  You are currently offline. Please check your internet connection.
                </Alert>
              )}

              {/* Action buttons */}
              <div className="d-flex justify-content-center gap-3 mt-4">
                {canRetry ? (
                  <Button variant="primary" onClick={this.handleRetryFetch}>
                    <i className="bi bi-arrow-clockwise me-2"></i>
                    Retry Now
                  </Button>
                ) : isSessionError ? (
                  <Button variant="primary" onClick={() => window.location.href = '/motorquotes'}>
                    <i className="bi bi-arrow-left me-2"></i>
                    Start Over
                  </Button>
                ) : (
                  <Button variant="primary" onClick={this.handleRetryFetch} disabled>
                    <i className="bi bi-wifi-off me-2"></i>
                    Waiting for Connection...
                  </Button>
                )}

                <Button variant="outline-secondary" onClick={this.handleBackToVehicleDetails}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Go Back
                </Button>
              </div>

              {/* Help text */}
              <div className="mt-4 text-start">
                <small className="text-muted">
                  <strong>Troubleshooting tips:</strong>
                  <ul className="mt-2 mb-0">
                    {errorType === 'network' && (
                      <>
                        <li>Check your WiFi or mobile data connection</li>
                        <li>Try disabling and re-enabling your network</li>
                        <li>Check if other websites are loading</li>
                      </>
                    )}
                    {errorType === 'timeout' && (
                      <>
                        <li>Your internet connection might be slow</li>
                        <li>Try refreshing the page and starting again</li>
                        <li>Check with your network provider</li>
                      </>
                    )}
                    {errorType === 'server' && (
                      <>
                        <li>This is a temporary issue on our end</li>
                        <li>Please try again in a few minutes</li>
                        <li>If the issue persists, contact support</li>
                      </>
                    )}
                    {errorType === 'session' && (
                      <>
                        <li>Your session has expired due to inactivity</li>
                        <li>Please click "Start Over" to begin again</li>
                        <li>Your data is secure and has not been lost</li>
                      </>
                    )}
                    {(!errorType || errorType === 'api' || errorType === 'unknown') && (
                      <>
                        <li>Check your internet connection</li>
                        <li>Try refreshing the page</li>
                        <li>If the issue persists, contact support</li>
                      </>
                    )}
                  </ul>
                </small>
              </div>
            </Alert>
          </div>
        </div>
      );
    }

    return (
      <div className="bgalphacolor">
        <h3 className="logoskybluecolor">SATP Motor Insurance Quotes</h3>

        {/* Progress Steps */}
        <Row className="mb-4 SATPMotorQuotesPage">
          <Col className="col-md-3 Inactive">
            <div
              className="widget_BG widget_BG_grid nav-icon"
              onClick={this.handleBackToVehicleDetails}
              style={{ cursor: 'pointer' }}
            >
              <i className="bi bi-car-front-fill"></i>
              <p className="nav-label mt-2">Vehicle Details</p>
            </div>
          </Col>
          <Col className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid nav-icon">
              <i className="bi bi-file-richtext "></i>
              <p className="nav-label mt-2">Quotes</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid nav-icon">
              <i className="bi bi-info-square"></i>
              <p className="nav-label mt-2">Vehicle Info</p>
            </div>
          </Col>
          <Col className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid  nav-icon">
              <i className="bi bi-file-person"></i>
              <p className="nav-label mt-2">Customer Details</p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            {/* No quotes available */}
            {!baseQuoteData && !addonQuoteData && (
              <Alert variant="warning" className="text-center p-4">
                <h5>No Quotes Available</h5>
                <p>We couldn't retrieve your quote at this time. Please go back and submit your details again.</p>
                <Button variant="primary" onClick={this.handleBackToVehicleDetails}>
                  Go Back to Vehicle Details
                </Button>
              </Alert>
            )}

            {/* Base Quote Display */}
            {baseQuoteData && this.renderQuoteCard(baseQuoteData, false)}

            {/* Updated Quote with Add-ons */}
            {addonQuoteData && this.renderQuoteCard(addonQuoteData, true)}
          </Col>
        </Row>

        {/* Information Footer for SATP */}
        <Row className="mt-4">
          <Col>
            <Alert variant="info">
              <h6>SATP (Standalone Third Party) Policy Information</h6>
              <Row>
                <Col md={6}>
                  <ul className="mb-0 small">
                    <li>SATP covers only Third Party liability - no Own Damage coverage</li>
                    <li><strong>Mandatory covers:</strong> TPPD (₹6,000) and PA Owner-Driver (₹15,00,000)</li>
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="mb-0 small">
                    <li><strong>Optional liability covers:</strong> PA Paid Driver, PA Passengers, Legal Liability</li>
                    <li>OD add-ons (Return to Invoice, Depreciation, etc.) are NOT applicable for SATP</li>
                  </ul>
                </Col>
              </Row>
            </Alert>
          </Col>
        </Row>
      </div>
    );
  }
}